import React from "react";
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaPlusCircle, FaTrashAlt, FaCopy } from "react-icons/fa";
import { Tooltip } from "../../tooltip/index";
const autobind = require("class-autobind").default;
export class FieldDeliveryFeeRange extends React.Component {
    constructor(props) {
        super(props);
        autobind(this);
    }
    add() {
        const values = [...this.props.values];
        values.push({
            up_to: 0,
            cost: 0,
        });
        this.props.onChange(values);
    }
    copy(i) {
        const values = [...this.props.values];
        const value = { ...values[i] };
        values.push(value);
        this.props.onChange(values);
    }
    remove(i) {
        const values = ([...this.props.values]);
        values.splice(i, 1);
        this.props.onChange(values);
    }
    change(i, key, value) {
        const values = [...this.props.values];
        values[i][key] = value;
        this.props.onChange(values);
    }
    render() {
        const { values, currencySymbol } = this.props;
        const units = this.props.kmmile === "KM" ? "kilometers" : "miles";
        return (React.createElement("div", null,
            values.length === 0 &&
                React.createElement(Button, { size: "xs", color: "primary-inverse", type: "button", onClick: this.add }, "Create Price Bracket"),
            values.map((item, i) => {
                return (React.createElement("div", { key: i, className: "flex-line m-t-3", style: { alignItems: "flex-end" } },
                    React.createElement(InputBox, { className: "no-round width32 text-center" },
                        React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, i + 1)),
                    React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                        React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ?
                                `Between 0 to ${values[i].up_to || "X"} ${units}` :
                                `Between ${values[i - 1].up_to || "X"} to ${values[i].up_to || "X"} ${units}`, small_title: true, no_border: true },
                            React.createElement(Input, { placeholder: `"Up to X ${units}"`, required: true, type: "number", step: 0.01, className: "no-round", style: { width: "220px" }, value: item.up_to, onChange: (e) => this.change(i, "up_to", parseFloat(e.target.value) || 0) })),
                        React.createElement(FormGroup, { className: "m-b-0", title: `Cost (${currencySymbol || "$"})`, small_title: true, no_border: true },
                            React.createElement(Input, { type: "number", required: true, step: 0.01, className: "no-round", style: { width: "150px" }, value: item.cost, onChange: (e) => this.change(i, "cost", parseFloat(e.target.value) || 0) }))),
                    (this.props.values.length - 1) === i &&
                        React.createElement(Tooltip, { text: "Add", width: 65, position: "top" },
                            React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: this.add },
                                React.createElement(FaPlusCircle, null))),
                    React.createElement(Tooltip, { text: "Delete", width: 65, position: "top" },
                        React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => this.remove(i) },
                            React.createElement(FaTrashAlt, null))),
                    React.createElement(Tooltip, { text: "Copy", width: 65, position: "top" },
                        React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => this.copy(i) },
                            React.createElement(FaCopy, null)))));
            })));
    }
}
//# sourceMappingURL=index.js.map